
import React, { useState } from 'react';

const Pagination = ({ postPerPage, totalPosts, paginate }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageNumbers = Math.ceil(totalPosts / postPerPage);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    paginate(pageNumber);
  };

  // Calculate pages to display (show 5 pages max with ellipses)
  const getPageNumbers = () => {
    const pages = [];
    let startPage = currentPage - 2 > 0 ? currentPage - 2 : 1;
    let endPage = currentPage + 2 <= pageNumbers ? currentPage + 2 : pageNumbers;

    // Adjust startPage if we are near the beginning
    if (currentPage - 2 < 1) {
      endPage = Math.min(3, pageNumbers); // Show 3 pages if near start
    }

    // Adjust endPage if we are near the end
    if (currentPage + 2 > pageNumbers) {
      startPage = Math.max(pageNumbers - 4, 1); // Show 3 pages if near end
    }

    // Add pages to the array
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  return (
    <div className='ml-5'>
      <nav>
        <ul className="pagination">
          {/* Previous Button */}
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <a onClick={() => handlePageChange(currentPage - 1)} className="page-link">
              Previous
            </a>
          </li>

          {/* Ellipses for the start */}
          {currentPage > 3 && (
            <li className="page-item">
              <span className="page-link">...</span>
            </li>
          )}

          {/* Page Numbers */}
          {getPageNumbers().map((number) => (
            <li
              key={number}
              className={`page-item ${currentPage === number ? 'active' : ''}`}
            >
              <a onClick={() => handlePageChange(number)} className="page-link">
                {number}
              </a>
            </li>
          ))}

          {/* Ellipses for the end */}
          {currentPage < pageNumbers - 2 && (
            <li className="page-item">
              <span className="page-link">...</span>
            </li>
          )}

          {/* Next Button */}
          <li className={`page-item ${currentPage === pageNumbers ? 'disabled' : ''}`}>
            <a onClick={() => handlePageChange(currentPage + 1)} className="page-link">
              Next
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
